query allExtHockeyTeams(
  $first: Int
  $offset: Int
  $filter: HockeyTeamMappingFilter
) {
  allHockeyTeamMappings(first: $first, offset: $offset, filter: $filter) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      intId
      mappedEntity {
        name
        source
        teamId
      }
    }
    totalCount
  }
}
